import React from 'react';
import { MBaseTextField } from '../BaseTextField/BaseTextField';

export const FormikField: React.FC<any> = (props) => {
  const {
    inputComponent: InputComponent = MBaseTextField,
    name,
    formik,
    ...otherProps
  } = props;
  return (
    <InputComponent
      name={name}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      errorText={formik.errors[name]}
      value={formik.values[name]}
      {...otherProps}
    />
  );
};
